var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kv-pair"},[_c('label',[_vm._v(_vm._s(_vm.k)+": ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.v)),_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c97231c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/monitor/components/RecordDetail/KeyValue.vue
// module id = 411
// module chunks = 1